
import {define} from "observable:runtime";
import asset1 from "../style.css?url";

const assets = new Map([
  ["../style.css", asset1]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {installThemeToggle} = await import("../lib/helpers.js").then((module) => {
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  return module;
});
installThemeToggle({ html, display });
return {installThemeToggle};
},
    inputs: ["html","display"],
    outputs: ["installThemeToggle"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
